<template>
  <div class="documents-section" v-loading="isLoading">
    <div class="section-header">
      <h3 class="section-title">Practice Documents</h3>
      <div class="header-actions">
        <ResponsiveButton
        v-component-loading = "deletingBatch"
        size="medium"
        display_name = "Delete By Batch"
        button_type = "outlined"
        built_in_theme = "error"
        @click-button="handleDeleteBatch"
        :disabled="checkedIds.length === 0 || deletingBatch"
        >
          <template #prefix>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M15 3V4H20V6H19V19C19 20.1 18.1 21 17 21H7C5.9 21 5 20.1 5 19V6H4V4H9V3H15ZM7 19H17V6H7V19ZM9 8H11V17H9V8ZM15 8H13V17H15V8Z" fill="currentColor"/>
            </svg>
          </template>
        </ResponsiveButton>
        <!-- <Button
          v-if="isAdmin"
          color-type="red-stroke"
          @click="handleDeleteBatch"
          :disabled="checkedIds.length === 0 || deletingBatch"
          :loading="deletingBatch"
        >
          <div style="display: flex; align-items: center; gap: 8px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M15 3V4H20V6H19V19C19 20.1 18.1 21 17 21H7C5.9 21 5 20.1 5 19V6H4V4H9V3H15ZM7 19H17V6H7V19ZM9 8H11V17H9V8ZM15 8H13V17H15V8Z" fill="currentColor"/>
            </svg>
            <span>Delete By Batch</span>
          </div>
        </Button> -->
        <ResponsiveButton
        size="medium"
        display_name = "Upload Document"
        button_type = "outlined"
        built_in_theme = "dark"
        @click-button="handleUpload"
        >
          <template #prefix>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20ZM8 15.01L9.41 16.42L11 14.84V19H13V14.84L14.59 16.43L16 15.01L12.01 11L8 15.01Z" fill="#374957"/>
            </svg>
          </template>
        </ResponsiveButton>
        <!-- <Button
          color-type="dark-blue-stroke"
          @click="handleUpload"
        >
          <div style="display: flex; align-items: center; gap: 8px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20ZM8 15.01L9.41 16.42L11 14.84V19H13V14.84L14.59 16.43L16 15.01L12.01 11L8 15.01Z" fill="#374957"/>
            </svg>
            <span>Upload Document</span>
          </div>
        </Button> -->
      </div>
    </div>

    <div class="search-filter-row">
      <div class="search-input-wrapper">
        <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#666">
          <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
        </svg>
        <TextInput 
        v-model="searchQuery"
        size="medium"
        type="text"
        placeholder="Search"  
        @input="onSearchDebounced"/>
        <!-- <input
          v-model="searchQuery"
          type="text"
          placeholder="Search"
          class="search-input"
          @input="onSearchDebounced"
        /> -->
      </div>
      <div class = "documents-type-selector-wrapper">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z" fill="#374957"/>
        </svg>
        <SingleSelector 
        v-model="filterType" 
        :options="documentTypeOptions" 
        size="medium" 
        @change="onDocumentTypeSelected"/>
        <!-- <SimpleSelector
          v-model:currentElementType="filterType"
          :elements="documentTypeOptions"
          class="filter-select"
          @element-selected="onDocumentTypeSelected"
        /> -->
      </div>
     
    </div>

    <div class="documents-table">
      <div class="table-header">
        <div v-if="isAdmin" class="th-cell checkbox-col">
          <Checkbox
            :status="checkAllStatus"
            :isAll="true"
            @changeStatus="toggleSelectAll"
          />
        </div>
        <div class="th-cell name-col">Document Name</div>
        <div class="th-cell added-by-col">Added By</div>
        <div class="th-cell date-col">Created Date</div>
        <div v-if="isAdmin" class="th-cell actions-col">Actions</div>
      </div>

      <div v-if="!documents.length" class="table-empty">
        No documents found.
      </div>

      <div class="documents-data-container">
        <div
          v-for="doc in documents"
          :key="doc.id"
          class="table-row"
        >
          <div v-if="isAdmin" class="td-cell checkbox-col">
            <Checkbox
              :status="checkedIds.includes(doc.id) ? 'checked' : 'uncheck'"
              @changeStatus="() => toggleCheck(doc.id)"
            />
          </div>
          <div class="td-cell name-col">
            <span class="doc-name">{{ doc.name || doc.title }}</span>
          </div>
          <div class="td-cell added-by-col">
            <div class="added-by-content">
              <span class="added-by-text">{{ getProviderInfo(doc.uploaded_by).name }}</span>
              <div v-if="getProviderInfo(doc.uploaded_by).name !== '—'" class="added-by-icon">
                <svg v-if="getProviderInfo(doc.uploaded_by).isAdmin" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.08496 17.5V16.85C4.08496 16.51 4.24496 16.19 4.49496 16.04C6.18496 15.03 8.11496 14.5 10.085 14.5C10.115 14.5 10.135 14.5 10.165 14.51C10.265 13.81 10.465 13.14 10.755 12.53C10.535 12.51 10.315 12.5 10.085 12.5C7.66496 12.5 5.40496 13.17 3.47496 14.32C2.59496 14.84 2.08496 15.82 2.08496 16.85V19.5H11.345C10.925 18.9 10.595 18.22 10.375 17.5H4.08496Z" fill="#374957"/>
                  <path d="M10.085 11.5C12.295 11.5 14.085 9.71 14.085 7.5C14.085 5.29 12.295 3.5 10.085 3.5C7.87496 3.5 6.08496 5.29 6.08496 7.5C6.08496 9.71 7.87496 11.5 10.085 11.5ZM10.085 5.5C11.185 5.5 12.085 6.4 12.085 7.5C12.085 8.6 11.185 9.5 10.085 9.5C8.98496 9.5 8.08496 8.6 8.08496 7.5C8.08496 6.4 8.98496 5.5 10.085 5.5Z" fill="#374957"/>
                  <path d="M20.835 15.5C20.835 15.28 20.805 15.08 20.775 14.87L21.915 13.86L20.915 12.13L19.465 12.62C19.145 12.35 18.785 12.14 18.385 11.99L18.085 10.5H16.085L15.785 11.99C15.385 12.14 15.025 12.35 14.705 12.62L13.255 12.13L12.255 13.86L13.395 14.87C13.365 15.08 13.335 15.28 13.335 15.5C13.335 15.72 13.365 15.92 13.395 16.13L12.255 17.14L13.255 18.87L14.705 18.38C15.025 18.65 15.385 18.86 15.785 19.01L16.085 20.5H18.085L18.385 19.01C18.785 18.86 19.145 18.65 19.465 18.38L20.915 18.87L21.915 17.14L20.775 16.13C20.805 15.92 20.835 15.72 20.835 15.5ZM17.085 17.5C15.985 17.5 15.085 16.6 15.085 15.5C15.085 14.4 15.985 13.5 17.085 13.5C18.185 13.5 19.085 14.4 19.085 15.5C19.085 16.6 18.185 17.5 17.085 17.5Z" fill="#374957"/>
                </svg>
                <svg v-else-if="getProviderInfo(doc.uploaded_by).isProvider" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.9996 4C10.2536 4 8.83347 5.40258 8.83347 7.12656V8.74635C8.83347 10.4705 10.2536 11.873 11.9996 11.873C13.7458 11.873 15.1658 10.4705 15.1658 8.74635V7.12656C15.1658 5.40258 13.7458 4 11.9996 4Z" fill="#374957"/>
                  <path d="M18.9825 15.9476C17.9686 14.2417 16.3481 12.977 14.4194 12.3864C14.3747 12.3727 14.3263 12.3844 14.293 12.4169C13.3958 13.2903 12.281 13.9718 12.0023 14.1364C11.7048 13.9486 10.4516 13.1421 9.70661 12.4169C9.67343 12.3844 9.62469 12.3727 9.58022 12.3864C7.65128 12.9771 6.03087 14.2418 5.0174 15.9478C4.9942 15.9868 4.9942 16.0353 5.0174 16.0744C6.45659 18.4958 9.13208 20 11.9998 20C14.8677 20 17.5433 18.4958 18.9825 16.0744C19.0058 16.0352 19.0058 15.9867 18.9825 15.9476ZM16.3061 16.8802C16.3061 16.9492 16.2396 17.0019 16.1699 17.0019H15.3123C15.2425 17.0019 15.1662 17.0612 15.1662 17.1303V18.0059C15.1662 18.0748 15.1289 18.1274 15.059 18.1274H14.2889C14.219 18.1274 14.1532 18.0748 14.1532 18.0059V17.1303C14.1529 17.0613 14.1052 17.0019 14.0353 17.0019H13.1409C13.071 17.0019 13.0132 16.9491 13.0132 16.8802V16.1263C13.0132 16.0573 13.071 16.0017 13.1409 16.0017H14.0353C14.1052 16.0017 14.1529 15.9453 14.1529 15.8762V14.9996C14.1529 14.9306 14.2187 14.8762 14.2886 14.8762H15.0505C15.1202 14.8762 15.1661 14.9306 15.1661 14.9996V15.8788C15.1661 15.9479 15.2338 16.0015 15.3038 16.0015H16.1699C16.2396 16.0015 16.3061 16.0599 16.3061 16.1289V16.8802Z" fill="#374957"/>
                </svg>
              </div>
            </div>
          </div>
          <div class="td-cell date-col">{{ formatDate(doc.created_at || doc.updated_at) }}</div>
          <div v-if="isAdmin" class="td-cell actions-col" v-loading = "deletingDocId === doc.id " >
            <FoldableButton 
              text="Delete"
              built_in_theme="red"
              @click="handleDeleteSingleDocument(doc)"
              :transition_duration="0.5"
            >
              <template #prefix>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0V1H16V3H15V16C15 17.1 14.1 18 13 18H3C1.9 18 1 17.1 1 16V3H0V1H5V0H11ZM3 16H13V3H3V16ZM5 5H7V14H5V5ZM11 5H9V14H11V5Z" fill="currentColor"/>
                </svg>
              </template>
            </FoldableButton>
            <!-- <ActionButton
              text="Delete"
              default-color="#D10000"
              hover-text-color="#F63B3B"
              pressed-text-color="#A60B0B"
              hover-bg-color="rgba(209, 0, 0, 0.08)"
              pressed-bg-color="rgba(209, 0, 0, 0.12)"
              @click="handleDeleteSingleDocument(doc)"
            >
              <template #prefix>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0V1H16V3H15V16C15 17.1 14.1 18 13 18H3C1.9 18 1 17.1 1 16V3H0V1H5V0H11ZM3 16H13V3H3V16ZM5 5H7V14H5V5ZM11 5H9V14H11V5Z" fill="currentColor"/>
                </svg>
              </template>
            </ActionButton> -->
          </div>
        </div>
      </div>
    </div>

    <div v-if="totalCount > 0" class="table-pagination">
      <Pagination
        v-model:current_page="currentPage"
        v-model:per_page="pageSize"
        :total_items="totalCount"
        :per_page_options="[10, 20, 50]"
        item_label="results"
        :show_summary="false"
      />
      <!-- <MedicationPagination
        :total="totalCount"
        :pageSize="pageSize"
        :currentPage="currentPage"
        :pageSizeOptions="[10, 20, 50]"
        @page-change="handlePageChange"
        @page-size-change="handlePageSizeChange"
      /> -->
    </div>

    <!-- Upload Document Modal -->
    <UploadDocumentModal
      :visible="showUploadModal"
      :allowedMIMETypes="allowedMIMETypes"
      @close="showUploadModal = false"
      @upload-success="handleUploadSuccess"
    />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import moment from 'moment';
import MedicationPagination from '@/NewLibrary/MedicationPagination.vue';
import SimpleSelector from '@/views/commonComponents/SimpleSelector.vue';
import Button from '@/NewLibrary/Button.vue';
import ActionButton from '@/views/commonComponents/ActionButton.vue';
import Checkbox from '@/NewLibrary/Checkbox.vue';
import UploadDocumentModal from '@/views/commonComponents/UploadDocumentModal.vue';
import { uploadDocumentApi } from '@/api/clinicDashboard';
import { notify } from '@/utils/notify';

// ========================================================================
// Component Setup
// ========================================================================
const emit = defineEmits(['view-document', 'upload-document', 'delete-batch', 'delete-document']);

const store = useStore();
let searchTimer = null;

// ========================================================================
// Reactive State
// ========================================================================
const deletingDocId = ref(null);
const deletingBatch = ref(false);
const showUploadModal = ref(false);

// ========================================================================
// Computed Properties - Store Data
// ========================================================================
const isLoading = computed(() => store.state.myPractice.clinicDashboard.practiceDocumentsTableLoading);
const documents = computed(() => store.getters['myPractice/clinicDashboard/practiceDocumentsTableData']);
const totalCount = computed(() => store.getters['myPractice/clinicDashboard/practiceDocumentsTableTotal']);
const checkedIds = computed(() => store.state.myPractice.clinicDashboard.checkedPracticeDocumentIds);
const providersList = computed(() => store.state.myPractice.clinicDashboard.providersList);
const isAdmin = computed(() => store.getters['login/isAdmin']);

const storeFilters = computed(() => store.state.myPractice.clinicDashboard.practiceDocumentsTableFilters);

// ========================================================================
// Local Filter State
// ========================================================================
const searchQuery = ref('');
const filterType = ref('all');
const currentPage = ref(1);
const pageSize = ref(storeFilters.value.pageSize || 10);

// Restore filters from store on mount
onMounted(() => {
  const filters = store.state.myPractice.clinicDashboard.practiceDocumentsTableFilters;
  
  if (filters.search) {
    searchQuery.value = filters.search;
  }
  
  if (filters.documentType) {
    filterType.value = filters.documentType.split(',');
  } else {
    filterType.value = 'all';
  }
  
  if (filters.page) {
    currentPage.value = filters.page;
  }
});

// ========================================================================
// Constants
// ========================================================================
const documentTypeOptions = [
  { value: 'all', label: 'All Documents', iconSvg: '' },
  { value: 'application/pdf', label: 'PDF Documents', iconSvg: '' },
  { value: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'], label: 'Word Documents', iconSvg: '' },
  { value: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'], label: 'Excel Documents', iconSvg: '' },
  { value: 'text/plain', label: 'Text Documents', iconSvg: '' },
  { value: 'text/csv', label: 'CSV Documents', iconSvg: '' },
  { value: ['image/png', 'image/jpeg'], label: 'Image Documents', iconSvg: '' }
];
const allowedMIMETypes = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/csv',
  'text/plain',
  'image/png',
  'image/jpeg'
];


// ========================================================================
// Computed Properties - Checkbox State
// ========================================================================
const isAllChecked = computed(() =>
  documents.value.length > 0 && documents.value.every((d) => checkedIds.value.includes(d.id))
);
const isIndeterminate = computed(() =>
  checkedIds.value.length > 0 && !isAllChecked.value
);

const checkAllStatus = computed(() => {
  if (documents.value.length === 0) return 'uncheck';
  if (isAllChecked.value) return 'checked';
  if (checkedIds.value.length > 0) return 'partial';
  return 'uncheck';
});

// ========================================================================
// Helper Functions
// ========================================================================
function buildFilterParams(resetPage = false) {
  return {
    search: searchQuery.value,
    documentType: filterType.value === 'all' ? '' : String(filterType.value),
    page: resetPage ? 1 : currentPage.value,
    pageSize: pageSize.value
  };
}

function updateFiltersAndFetch(resetPage = false) {
  if (resetPage) {
    currentPage.value = 1;
  }
  const filters = buildFilterParams(resetPage);
  store.commit('myPractice/clinicDashboard/SET_PRACTICE_DOCUMENTS_TABLE_FILTERS', filters);
  store.dispatch('myPractice/clinicDashboard/fetchPracticeDocumentsData');
}

// ========================================================================
// Checkbox Handlers
// ========================================================================
function toggleSelectAll(status) {
  if (status === 'checked') {
    const ids = documents.value.map((d) => d.id);
    store.commit('myPractice/clinicDashboard/SET_CHECKED_PRACTICE_DOCUMENT_IDS', ids);
  } else {
    store.commit('myPractice/clinicDashboard/SET_CHECKED_PRACTICE_DOCUMENT_IDS', []);
  }
}

function toggleCheck(id) {
  const current = [...checkedIds.value];
  const idx = current.indexOf(id);
  if (idx > -1) current.splice(idx, 1);
  else current.push(id);
  store.commit('myPractice/clinicDashboard/SET_CHECKED_PRACTICE_DOCUMENT_IDS', current);
}

// ========================================================================
// Search and Filter Handlers
// ========================================================================
function onSearchDebounced() {
  clearTimeout(searchTimer);
  searchTimer = setTimeout(() => {
    updateFiltersAndFetch(true);
  }, 400);
}

function onDocumentTypeSelected(element) {
  filterType.value = element.value;
  updateFiltersAndFetch(true);
}

// ========================================================================
// Pagination Handlers
// ========================================================================
watch(currentPage, () => {
  updateFiltersAndFetch(false);
});
watch(pageSize, () => {
  currentPage.value = 1;
  updateFiltersAndFetch(false);
});

// function handlePageChange(page) {
//   currentPage.value = page;
//   updateFiltersAndFetch(false);
// }

// function handlePageSizeChange(newSize) {
//   pageSize.value = newSize;
//   updateFiltersAndFetch(true);
// }

// ========================================================================
// Delete Handlers
// ========================================================================
async function handleDeleteSingleDocument(doc) {
  deletingDocId.value = doc.id;
  try {
    await store.dispatch('myPractice/clinicDashboard/deletePracticeDocumentsBatch', [doc.id]);
  } catch (error) {
    console.error('Failed to delete document:', error);
  } finally {
    deletingDocId.value = null;
  }
}

async function handleDeleteBatch() {
  if (checkedIds.value.length === 0) return;
  deletingBatch.value = true;
  try {
    await store.dispatch('myPractice/clinicDashboard/deletePracticeDocumentsBatch', checkedIds.value);
    store.commit('myPractice/clinicDashboard/SET_CHECKED_PRACTICE_DOCUMENT_IDS', []);
  } catch (error) {
    console.error('Failed to delete documents:', error);
  } finally {
    deletingBatch.value = false;
  }
}

// ========================================================================
// Upload Handlers
// ========================================================================
function handleUpload() {
  showUploadModal.value = true;
}

async function handleUploadSuccess(files) {
  if (!files || files.length === 0) {
    return;
  }

  const clinicId = store.state?.login?.userInfo?.clinic_id;
  if (!clinicId) {
    console.error('Clinic ID not found');
    return;
  }

  // Upload all files using Promise.allSettled
  const uploadPromises = files.map(async (fileData) => {
    try {
      const formData = new FormData();
      formData.append('file', fileData.file);
      formData.append('clinic_id', clinicId);
      formData.append('title', fileData.name);
      
      const response = await uploadDocumentApi(formData);
      notify({ type: 'success', message: `"${fileData.name}" has been uploaded` });
      return { status: 'fulfilled', value: response, fileName: fileData.name };
    } catch (error) {
      console.error(`Failed to upload ${fileData.name}:`, error);
      notify({ type: 'error', message: `Failed to upload "${fileData.name}"` });
      return { status: 'rejected', reason: error, fileName: fileData.name };
    }
  });

  const results = await Promise.allSettled(uploadPromises);
  
  // Log results
  const successful = results.filter(r => r.status === 'fulfilled' && r.value.status === 'fulfilled').length;
  const failed = results.length - successful;
  
  if (successful > 0) {
    console.log(`Successfully uploaded ${successful} document(s)`);
  }
  if (failed > 0) {
    console.error(`Failed to upload ${failed} document(s)`);
  }

  // Refresh documents list
  store.dispatch('myPractice/clinicDashboard/fetchPracticeDocumentsData');
}

// ========================================================================
// Utility Functions
// ========================================================================
function getProviderInfo(uploadedBy) {
  if (!uploadedBy) return { name: '—', role: null, isAdmin: false };
  
  const provider = providersList.value.find(p => String(p.customer_id) === String(uploadedBy));
  
  if (!provider) {
    return { name: 'Inactive Provider', role: null, isAdmin: false };
  }
  const roles = provider.customer_roles.map(item => item.customer_role);
  const isAdmin = roles.includes('clinicadmin') || roles.includes('clinic_admin') || roles.includes('clinic') || roles.includes('admin');
  const isProvider = roles.includes('provider') || roles.includes('customer');
  const name = isAdmin ? 'Admin' : (provider.name || `${provider.customer_first_name || ''} ${provider.customer_last_name || ''}`.trim() || 'Provider');
  
  return { name, role: provider.role, isAdmin, isProvider };
}

function formatDate(dateStr) {
  if (!dateStr) return '—';
  return moment(dateStr).format('MMM DD, YYYY');
}

</script>

<style scoped>
.documents-section {
  background: #F9FBFD;
  border-radius: 10px;
  padding: 16px 24px;
  max-height: 584px;
  display: flex;
  flex-direction: column;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.section-title {
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  color: #333;
  margin: 0;
  flex: 1;
}

.header-actions {
  display: flex;
  gap: 8px;
}


.search-filter-row {
  display: flex;
  gap: 20px;
  margin-bottom: 12px;
}

.search-input-wrapper {
  width: calc(50% - 10px);
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-input {
  flex: 1;
  height: 40px;
  padding: 8px 12px;
  border: 1px solid #C9C9C9;
  border-radius: 4px;
  background: white;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #333;
}

.search-input::placeholder {
  color: #999;
}

.search-input:focus {
  outline: none;
  border-color: #004879;
}

.documents-type-selector-wrapper{
  width: calc(50% - 10px);
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-select {
  flex: 1;
}

.documents-table {
  background: white;
  border-radius: 10px;
  box-shadow: 0 1px 15px 0 rgba(164, 164, 164, 0.25);
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.table-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  background: #FDF9F6;
  border-bottom: 1px solid #C4C4C4;
}

.th-cell {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #666;
}

.documents-data-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
}

.table-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  border-bottom: 1px solid #C4C4C4;
  transition: background 0.15s;
  background: white;
}

.table-row:hover {
  background: #F9FBFD;
}

.table-row:last-child {
  border-bottom: none;
}

.td-cell {
  font-family: 'IBM Plex Sans Hebrew', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333;
}

.checkbox-col { width: 28px; flex-shrink: 0; }
.name-col { width: 440px; flex-shrink: 0; overflow: hidden; }
.added-by-col { flex: 1; min-width: 0; text-align: center; }
.date-col { flex: 1; min-width: 0; text-align: center; }
.actions-col { width: 114px; flex-shrink: 0; text-align: center; }

.th-cell.added-by-col,
.th-cell.date-col,
.th-cell.actions-col {
  border-left: 1px solid #C4C4C4;
}

.doc-name {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.added-by-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.added-by-text {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #666;
  white-space: nowrap;
}

.added-by-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.added-by-icon svg {
  width: 24px;
  height: 24px;
}


.table-empty {
  text-align: center;
  color: #9CA3AF;
  padding: 32px 0;
  font-size: 14px;
}

.table-pagination {
  padding: 16px 0 0;
}
/* SingleSelector styles - same as ez-bill */
.documents-section :deep(.new-libary-single-selector .el-select__wrapper) {
  border: 1px solid #C4C4C4 !important;
  box-shadow: none !important;
  height: 40px !important;
  min-height: 40px !important;
}

.documents-section :deep(.new-libary-single-selector .el-select__wrapper:hover),
.documents-section :deep(.new-libary-single-selector .el-select__wrapper.is-focus) {
  border: 1px solid #C4C4C4 !important;
  box-shadow: none !important;
  height: 40px !important;
}
</style>
